export default "__VITE_ASSET__B$pzGeox__"